<template>
  <div v-if="currentTrailType == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar tipología</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
              <trail-type-form :entity="currentTrailType" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import TrailTypeForm from "./TrailTypeForm.vue";


    const store = useStore();
    const route = useRoute();

    const getCurrentTrailType = async (id) => {
      return await store.dispatch("trailType/getTrailTypeById", id);
    };

    const currentTrailType = computed(() => {
      if(!store.state.trailType.currentTrailType) return null

      return store.state.trailType.currentTrailType
    });

    onMounted(()=>{
      getCurrentTrailType(route.params.id)
    });

</script>
